<template>
  <el-form :model="form" :rules="rules" class="login-form" ref="form">
    <div class="title">立即预约演示</div>
    <div class="sub-title">（积加ERP软件顾问最快将在10分钟内与您确认系统演示的时间）</div>
    <el-form-item class="login-phoneNumber" prop="phoneNumber">
      <el-input placeholder="请输入手机号" v-model="form.phoneNumber">
        <template slot="prefix">
          <i class="el-input__icon el-icon-mobile-phone"></i>
          <gj-select
              :clearable="false"
              :filterable="false"
              :options="codeOptions"
              v-model="form.telephoneCode"
              width="85px"
          ></gj-select>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-input
          placeholder="请输入验证码"
          prefix-icon="el-icon-s-claim"
          v-model="form.code"
          auto-complete="new-password"
      >
        <template slot="suffix">
          <gj-button
              plain
              type="ghost"
              size="mini"
              :disabled="registerCaptchaDisabled"
              @click="registerCaptcha()"
          >
            <template v-if="registerCaptchaDisabled">
              {{ registerCaptchaTime }}s后重发
            </template>
            <template v-else>
              获取验证码
            </template>
          </gj-button>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="name">
      <el-input
          placeholder="请输入您的称呼"
          prefix-icon="el-icon-user"
          v-model="form.name"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="tenantName">
      <el-input
          placeholder="请输入您的公司名"
          prefix-icon="el-icon-office-building"
          v-model="form.tenantName"
      >
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button
          style="width: 250px;"
          type="primary"
          :loading="loading"
          @click="register()"
      >
        预约演示
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import { USER_REGISTER } from "../../../../store/action-types";
  import {
    isMeaningful,
    isNotBlank,
    queryParamsMap,
  } from "../../../../utils/common";
  import { registerCaptcha } from "@/api/user";
  import { uploadConvertData } from "@/api/tool";
  import { responseMixin } from "@/minxins";
  import AppUserProtocolModal from "./modal/user-protocol-modal";
  import { tcAuthCode } from "@/utils/common";
  export default {
    name: "app-phone-login",
    mixins: [responseMixin],
    data() {
      const checkPhoneNumber = (rule, value, callback) => {
        const reg = this.regs[this.form.telephoneCode]
        if (!reg.test(value)) {
          return callback(new Error("手机号码格式不正确"));
        } else {
          return callback();
        }
      };
      const checkPasswords = (rule, value, callback) => {
        if (value !== this.form.password) {
          return callback(new Error("两次输入密码不一致!"));
        } else {
          return callback();
        }
      };
      const checkPassword = (rule, value, callback) => {
        if (isNotBlank(value)) {
          //必须包含字母、数字，可以有（可有可没有）特殊字符  (x20是空格)
          const reg = /^(?=.*\d)(?=.*[A-Za-z])[\x21-\x7e]{6,20}$/;
          // const reg = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/;
          if (!reg.test(value)) {
            callback(new Error("必须同时包含字母和数字，且长度在6-20位字符之间，区分大小写"));
          }
        }
        callback();
      };
      return {
        form: {
          phoneNumber: null,
          code: null,
          password: this.generatePassword(6, 2),
          name: '',
          tenantName: '',
          userP: false,
          salesCode: null,
          bd_vid: null,
          fromWebsite: null,
          referer: null,
          telephoneCode: '86'
        },
        codeOptions: [
          {id: '86', text: '+86(CN)'},
          {id: '1', text: '+1 (US)'},
        ],
        regs: {
          // '86': /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
          '86': /^(\d{10}|\d{11})$/,
          '1': /^(\d{10}|\d{11})$/
        },
        rules: {
          phoneNumber: [
            {
              required: true,
              message: "请输入手机号",
              trigger: ["blur", "change"],
            },
            {
              required: true,
              message: "手机号码格式不正确",
              validator: checkPhoneNumber,
              trigger: ["blur"],
            },
          ],
          code: [
            {
              required: true,
              message: "请输入验证码",
              trigger: ["blur", "change"],
            },
          ],
        },
        registerCaptchaDisabled: false,
        registerCaptchaTime: null,
        formValid: true,
        loading: false,

      };
    },
    watch: {
      $route: {
        handler: function(route) {
          if (isMeaningful(route.query.salesCode)) {
            this.form.salesCode = route.query.salesCode;
            window.localStorage.setItem('salesCode', route.query.salesCode);
          }
          if (isMeaningful(route.query.bd_vid)) {
            this.form.bd_vid = route.query.bd_vid;
            window.localStorage.setItem('bd_vid', route.query.bd_vid);
          }
          if (isMeaningful(route.query.from_website)) {
            this.form.fromWebsite = route.query.from_website;
          }
          this.form.referer = route.query.referer;
        },
        immediate: true,
      },
    },
    methods: {
      registerCaptcha() {
        this.$refs.form.validateField("phoneNumber", (err) => {
          if (err) { // 手机号码校验不通过
            return
          }
          // 腾讯图形验证码
          tcAuthCode(this.form.phoneNumber).then(resolve => {
            // 验证完成
            if (!err) {
              this.registerCaptchaDisabled = true;
              this.registerCaptchaTime = 120;
              const intervalHandle = setInterval(() => {
                if (this.registerCaptchaTime > 0) {
                  this.registerCaptchaTime--;
                } else {
                  this.registerCaptchaDisabled = false;
                  clearInterval(intervalHandle);
                }
              }, 1000);
              registerCaptcha({ mobile: this.form.phoneNumber, code:resolve}, this.form.telephoneCode).then((res) => {
                this.$gjResponseHandle(
                  res,
                  () => {},
                  () => {
                    this.$gjMessage({
                      message: res.msg || "网络错误，请重试",
                      type: "error",
                      duration: 3000,
                    });
                    this.registerCaptchaDisabled = false;
                    clearInterval(intervalHandle);
                  }
                );
              }).catch(requestErr => { // code小于0
                this.registerCaptchaDisabled = false;
                clearInterval(intervalHandle);
              })
            }
          }).catch(error => {
            // 验证不通过
            console.log(error)
          })
        })
      },
      uploadConvertData() {
        const bd_vid =  window.localStorage.getItem('bd_vid');
        const salesCode = this.form.salesCode ||'';
        // BEBEIIDFFCGDJFAEDIF 是B1渠道
        const tokenType = salesCode.indexOf('BEBEIIDFFCGDJFAEDIF') > -1 ? undefined: 'tokenTwo';
        if(isMeaningful(this.form.bd_vid) || bd_vid){
          uploadConvertData({
            tokenType,
            conversionTypes: [
              {
                  "logidUrl": window.decodeURIComponent(this.form.referer),
                  "newType": 3 //注册
              }
            ]
          });
        }
      },


      register() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const salesCode =  window.localStorage.getItem('salesCode');
            if(!isMeaningful(this.form.salesCode) && salesCode){
               this.form.salesCode = salesCode;
            }
            this.loading = true;
            this.$store
              .dispatch(USER_REGISTER, this.form)
              .then((res) => {
                this.$emit("after-login");
                this.$gjMessage({
                  message: "预约成功，请等待专属客服和您联系！",
                  type: "success",
                  duration: 3000,
                  offset: 200,
                  onClose: () => {
                    location.reload();
                  }
                });
                // 百度埋点
                this.uploadConvertData();
                if (window._czc) {
                  window._czc.push([
                    "_trackEvent",
                    "注册页",
                    "注册",
                    `渠道: ${this.form.referer || "无"}`,
                  ]);
                }
              })
              .catch((res) => {
                // this.$gjMessage({
                //   message: res.msg || "网络错误，请重试",
                //   type: "error",
                //   duration: 3000,
                // });
              })
              .complete(() => (this.loading = false));
          }
        });
      },
      openUserP() {
        this.$gjCreate(AppUserProtocolModal, {
          global: true,
          on: {
            agreed: () => {
              this.form.userP = true;
            },
          },
        });
      },
      toLogin() {
        this.$router.push(
          `/login?${queryParamsMap({
            salesCode: this.form.salesCode,
            referer: this.form.referer,
          })}`
        );
      },
      generatePassword(length, nums) {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'; // 包含大小写字母所有字符集合
        var numbers = '0123456789'; // 数字的所有字符集合
        var password = '';
        for (let i = 0; i < length; i++) {
          let randomIndex = Math.floor(Math.random() * characters.length); // 获取随机索引值
            password += characters[randomIndex]; // 将随机字符添加到密码中
        }
        for (let i = 0; i < nums; i++) {
          let randomIndex = Math.floor(Math.random() * numbers.length); // 获取随机索引值
          password += numbers[randomIndex]; // 将随机字符添加到密码中
        }
        return password;
      }
    },
  };
</script>

<style lang="scss" scoped>
.sub-title {
  color: #909399;
  font-size: 12px;
  margin-bottom: 20px;
}
  /deep/ .el-input-group__append {
    background: #fff;
    border-top: none;
    border-right: none;
    border-radius: 0;
  }

  @media (max-width: 864px) {
  }

  .login-phoneNumber{
    &/deep/.el-input__inner{
      padding-left: 110px;
    }
    &/deep/.el-input__prefix{
      display: flex;
      align-items: center;
    }
    &/deep/ .el-select__caret{
      color: #333333;
      font-weight: bold;
    }
    &/deep/.gj-select{
      .el-input__inner{
        padding: 0 0 0 5px;
        border: none;
        font-size: 13px;
      }
    }
  }
</style>
